export const customerAccess = {
  title: 'Ügyfél Hozzáférések',
  subtitle: '{{count}} hozzáférés',
  addAccess: 'Hozzáférés hozzáadása',
  addFirstAccess: 'Első hozzáférés hozzáadása',
  editAccess: 'Hozzáférés szerkesztése',
  noAccess: 'Nincs hozzáférés',
  noAccessDescription: 'Még nincs ügyfélportál hozzáférés ehhez a szervezethez. Adjon hozzá egyet az első lépésként.',
  neverLoggedIn: 'Még nem jelentkezett be',
  organization: 'Szervezet',

  columns: {
    user: 'Felhasználó',
    role: 'Szerepkör',
    status: 'Státusz',
    lastLogin: 'Utolsó bejelentkezés',
    actions: 'Műveletek',
  },

  role: {
    primary: 'Elsődleges kapcsolattartó',
    secondary: 'Másodlagos felhasználó',
  },

  status: {
    active: 'Aktív',
    inactive: 'Inaktív',
    pending: 'Függőben',
  },

  actions: {
    edit: 'Szerkesztés',
    delete: 'Törlés',
    resendInvitation: 'Meghívó újraküldése',
  },

  form: {
    user: 'Felhasználó',
    selectUser: 'Válasszon felhasználót',
    userCannotChange: 'A felhasználó a létrehozás után nem módosítható',
    role: 'Szerepkör',
    status: 'Státusz',
    permissions: 'Jogosultságok',
    notes: 'Megjegyzések',
    notesPlaceholder: 'Opcionális megjegyzések erről a hozzáférésről...',
  },

  permissions: {
    canViewDocuments: 'Dokumentumok megtekintése',
    canUploadDocuments: 'Dokumentumok feltöltése',
    canViewInvoices: 'Számlák megtekintése',
    canCreateTickets: 'Jegyek létrehozása',
    canViewTickets: 'Jegyek megtekintése',
    canViewOrders: 'Rendelések megtekintése',
    canPlaceOrders: 'Rendelések leadása',
  },

  messages: {
    created: 'Hozzáférés sikeresen létrehozva',
    updated: 'Hozzáférés sikeresen frissítve',
    deleted: 'Hozzáférés sikeresen törölve',
    error: 'Hiba történt a hozzáférés mentése során',
    deleteError: 'Hiba történt a hozzáférés törlése során',
    invitationSent: 'Meghívó sikeresen elküldve',
    invitationError: 'Hiba történt a meghívó küldése során',
    activated: 'Hozzáférés aktiválva',
    deactivated: 'Hozzáférés letiltva',
    toggleError: 'Hiba történt a státusz módosítása során',
  },

  deleteModal: {
    title: 'Hozzáférés törlése',
    message: 'Biztosan törölni szeretné {{name}} hozzáférését?',
    warning: 'Ez a művelet nem vonható vissza. A felhasználó elveszíti a hozzáférést az ügyfélportálhoz.',
  },
};
